import { array } from 'yup';
import { requestJSON } from '../data/APIUtils';
import {
  VehicleMakeDTO,
  vehicleMakeSchema,
  VehicleModelDTO,
  vehicleModelSchema,
} from '../data/VehicleDTO';

export function fetchVehicleMakes(query: string): Promise<VehicleMakeDTO[]> {
  return requestJSON<VehicleMakeDTO[]>(
    `GET /internal/v1/vehicles/makes/search?query=${query}`,
    {
      schema: array(vehicleMakeSchema),
    },
  );
}

export function fetchVehiclePopularMakes(): Promise<VehicleMakeDTO[]> {
  return requestJSON<VehicleMakeDTO[]>(
    'GET /internal/v1/vehicles/makes/popular',
    {
      schema: array(vehicleMakeSchema),
    },
  );
}

export function fetchVehicleModels(
  makeId: number,
  query?: string | null,
): Promise<VehicleModelDTO[]> {
  return requestJSON<VehicleModelDTO[]>(
    query
      ? `GET /internal/v1/vehicles/${makeId}/models?query=${query}`
      : `GET /internal/v1/vehicles/${makeId}/models`,
    {
      schema: array(vehicleModelSchema),
    },
  );
}
